import * as Types from '../../gql.generated';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type ReadGdprRulesQueryVariables = {};


export type ReadGdprRulesQuery = (
  { __typename?: 'Query' }
  & { gdprRules: Array<(
    { __typename?: 'GDPRRule' }
    & Pick<Types.GdprRule, '_id' | 'ruleName' | 'retentionPeriod' | 'deletionPeriod' | 'created' | 'inactive' | 'modified'>
    & { createdBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )>, modifiedBy: Types.Maybe<(
      { __typename?: 'User' }
      & Pick<Types.User, '_id' | 'type' | 'upn' | 'firstName' | 'lastName' | 'name' | 'email' | 'department' | 'roles'>
    )> }
  )> }
);

export type CreateGdprRuleMutationVariables = {
  input?: Types.Maybe<Types.GdprRuleInsertType>
};


export type CreateGdprRuleMutation = (
  { __typename?: 'Mutation' }
  & { createGDPRRule: (
    { __typename?: 'GDPRRule' }
    & Pick<Types.GdprRule, '_id'>
  ) }
);

export type UpdateGdprRuleMutationVariables = {
  id?: Types.Maybe<Types.Scalars['ID']>,
  update?: Types.Maybe<Types.GdprRuleSetType>
};


export type UpdateGdprRuleMutation = (
  { __typename?: 'Mutation' }
  & { updateGDPRRule: Array<(
    { __typename?: 'GDPRRule' }
    & Pick<Types.GdprRule, '_id'>
  )> }
);

export type DeleteGdprRuleMutationVariables = {
  ids: Array<Types.Scalars['ID']>
};


export type DeleteGdprRuleMutation = (
  { __typename?: 'Mutation' }
  & { deleteGDPRRule: Array<(
    { __typename?: 'GDPRRule' }
    & Pick<Types.GdprRule, 'ruleName'>
  )> }
);

export type ConvolutesQueryVariables = {};


export type ConvolutesQuery = (
  { __typename?: 'Query' }
  & { convolutes: Array<(
    { __typename?: 'Convolute' }
    & Pick<Types.Convolute, 'type'>
    & { activeRuleset: Types.Maybe<(
      { __typename?: 'GDPRRule' }
      & Pick<Types.GdprRule, '_id' | 'ruleName' | 'retentionPeriod' | 'deletionPeriod'>
    )> }
  )> }
);

export type CreateOrUpdateConvoluteMutationVariables = {
  input: Types.ConvoluteInput
};


export type CreateOrUpdateConvoluteMutation = (
  { __typename?: 'Mutation' }
  & { createOrUpdateConvolute: (
    { __typename?: 'Convolute' }
    & Pick<Types.Convolute, '_id'>
  ) }
);

export const ReadGdprRulesDocument = gql`
    query ReadGdprRules {
  gdprRules {
    _id
    ruleName
    retentionPeriod
    deletionPeriod
    created
    inactive
    createdBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
    modified
    modifiedBy {
      _id
      type
      upn
      firstName
      lastName
      name
      email
      department
      roles
    }
  }
}
    `;

    export function useReadGdprRulesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ReadGdprRulesQuery, ReadGdprRulesQueryVariables>) {
      return ApolloReactHooks.useQuery<ReadGdprRulesQuery, ReadGdprRulesQueryVariables>(ReadGdprRulesDocument, baseOptions);
    };
      export function useReadGdprRulesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ReadGdprRulesQuery, ReadGdprRulesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ReadGdprRulesQuery, ReadGdprRulesQueryVariables>(ReadGdprRulesDocument, baseOptions);
      };
      
export type ReadGdprRulesQueryHookResult = ReturnType<typeof useReadGdprRulesQuery>;
export type ReadGdprRulesQueryResult = ApolloReactCommon.QueryResult<ReadGdprRulesQuery, ReadGdprRulesQueryVariables>;
export const CreateGdprRuleDocument = gql`
    mutation CreateGdprRule($input: GDPRRuleInsertType) {
  createGDPRRule(input: $input) {
    _id
  }
}
    `;
export type CreateGdprRuleMutationFn = ApolloReactCommon.MutationFunction<CreateGdprRuleMutation, CreateGdprRuleMutationVariables>;

    export function useCreateGdprRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateGdprRuleMutation, CreateGdprRuleMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateGdprRuleMutation, CreateGdprRuleMutationVariables>(CreateGdprRuleDocument, baseOptions);
    };
export type CreateGdprRuleMutationHookResult = ReturnType<typeof useCreateGdprRuleMutation>;
export type CreateGdprRuleMutationResult = ApolloReactCommon.MutationResult<CreateGdprRuleMutation>;
export type CreateGdprRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateGdprRuleMutation, CreateGdprRuleMutationVariables>;
export const UpdateGdprRuleDocument = gql`
    mutation UpdateGdprRule($id: ID, $update: GDPRRuleSetType) {
  updateGDPRRule(filter: {_id: {EQ: $id}}, update: {set: $update}) {
    _id
  }
}
    `;
export type UpdateGdprRuleMutationFn = ApolloReactCommon.MutationFunction<UpdateGdprRuleMutation, UpdateGdprRuleMutationVariables>;

    export function useUpdateGdprRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateGdprRuleMutation, UpdateGdprRuleMutationVariables>) {
      return ApolloReactHooks.useMutation<UpdateGdprRuleMutation, UpdateGdprRuleMutationVariables>(UpdateGdprRuleDocument, baseOptions);
    };
export type UpdateGdprRuleMutationHookResult = ReturnType<typeof useUpdateGdprRuleMutation>;
export type UpdateGdprRuleMutationResult = ApolloReactCommon.MutationResult<UpdateGdprRuleMutation>;
export type UpdateGdprRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateGdprRuleMutation, UpdateGdprRuleMutationVariables>;
export const DeleteGdprRuleDocument = gql`
    mutation DeleteGdprRule($ids: [ID!]!) {
  deleteGDPRRule(filter: {_id: {IN: $ids}}) {
    ruleName
  }
}
    `;
export type DeleteGdprRuleMutationFn = ApolloReactCommon.MutationFunction<DeleteGdprRuleMutation, DeleteGdprRuleMutationVariables>;

    export function useDeleteGdprRuleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteGdprRuleMutation, DeleteGdprRuleMutationVariables>) {
      return ApolloReactHooks.useMutation<DeleteGdprRuleMutation, DeleteGdprRuleMutationVariables>(DeleteGdprRuleDocument, baseOptions);
    };
export type DeleteGdprRuleMutationHookResult = ReturnType<typeof useDeleteGdprRuleMutation>;
export type DeleteGdprRuleMutationResult = ApolloReactCommon.MutationResult<DeleteGdprRuleMutation>;
export type DeleteGdprRuleMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteGdprRuleMutation, DeleteGdprRuleMutationVariables>;
export const ConvolutesDocument = gql`
    query convolutes {
  convolutes {
    type
    activeRuleset {
      _id
      ruleName
      retentionPeriod
      deletionPeriod
    }
  }
}
    `;

    export function useConvolutesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ConvolutesQuery, ConvolutesQueryVariables>) {
      return ApolloReactHooks.useQuery<ConvolutesQuery, ConvolutesQueryVariables>(ConvolutesDocument, baseOptions);
    };
      export function useConvolutesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ConvolutesQuery, ConvolutesQueryVariables>) {
        return ApolloReactHooks.useLazyQuery<ConvolutesQuery, ConvolutesQueryVariables>(ConvolutesDocument, baseOptions);
      };
      
export type ConvolutesQueryHookResult = ReturnType<typeof useConvolutesQuery>;
export type ConvolutesQueryResult = ApolloReactCommon.QueryResult<ConvolutesQuery, ConvolutesQueryVariables>;
export const CreateOrUpdateConvoluteDocument = gql`
    mutation createOrUpdateConvolute($input: ConvoluteInput!) {
  createOrUpdateConvolute(input: $input) {
    _id
  }
}
    `;
export type CreateOrUpdateConvoluteMutationFn = ApolloReactCommon.MutationFunction<CreateOrUpdateConvoluteMutation, CreateOrUpdateConvoluteMutationVariables>;

    export function useCreateOrUpdateConvoluteMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateOrUpdateConvoluteMutation, CreateOrUpdateConvoluteMutationVariables>) {
      return ApolloReactHooks.useMutation<CreateOrUpdateConvoluteMutation, CreateOrUpdateConvoluteMutationVariables>(CreateOrUpdateConvoluteDocument, baseOptions);
    };
export type CreateOrUpdateConvoluteMutationHookResult = ReturnType<typeof useCreateOrUpdateConvoluteMutation>;
export type CreateOrUpdateConvoluteMutationResult = ApolloReactCommon.MutationResult<CreateOrUpdateConvoluteMutation>;
export type CreateOrUpdateConvoluteMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateOrUpdateConvoluteMutation, CreateOrUpdateConvoluteMutationVariables>;